/**
 * Pet Mindful · Ventanas
 *
 * Abre cualquier <dialog> del tema desde un disparador con data-pm-qv-open:
 * la vista rápida de producto del home y las reseñas de la ficha. El diálogo
 * trae ya su contenido en el HTML —no hay fetch—, así que abre al instante y
 * funciona aunque la red esté lenta.
 *
 * Agregar al carrito no se toca aquí: el formulario lleva
 * data-type="add-to-cart-form" y el carrito lateral lo intercepta. Esto solo
 * cierra la ventana para que el drawer quede a la vista.
 *
 * Sin JS el «+» es un enlace a la ficha: nadie queda sin poder comprar.
 */
(() => {
  const open = (dialog, opener) => {
    if (!dialog || dialog.open) return;
    dialog.returnFocus = opener || null;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    adoptReviews(dialog);
  };

  /**
   * Klaviyo monta su listado al cargar la página, y un <dialog> cerrado es
   * display:none: ahí no hay ancho que medir ni nada que pintar. El widget
   * vive fuera, en un contenedor fuera de pantalla, y al abrir la ventana se
   * trae el nodo montado a su ranura. Al cerrar vuelve a su sitio, para que
   * siga siendo el mismo nodo la próxima vez.
   */
  const adoptReviews = (dialog) => {
    const slot = dialog.querySelector('[data-pm-reviews-slot]');
    if (!slot) return;

    const list = document.getElementById('klaviyo-reviews-list');
    if (!list) return;

    const host = list.closest('[data-pm-reviews-host]');
    if (host) host.removeAttribute('inert');
    slot.appendChild(list);

    // El fallback solo tiene sentido mientras el widget no haya escrito nada
    const fallback = dialog.querySelector('[data-pm-reviews-fallback]');
    if (fallback) fallback.hidden = list.children.length > 0;

    // Montado fuera de pantalla, el widget midió otro ancho
    window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  };

  const releaseReviews = (dialog) => {
    const list = dialog.querySelector('#klaviyo-reviews-list');
    if (!list) return;

    const host = document.querySelector('[data-pm-reviews-host]');
    if (!host) return;
    host.appendChild(list);
    host.setAttribute('inert', '');
  };

  const close = (dialog) => {
    if (!dialog || !dialog.open) return;
    releaseReviews(dialog);
    dialog.close();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-pm-qv-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.pmQvOpen);
      if (!dialog) return; // sin diálogo el enlace lleva a la ficha
      event.preventDefault();
      open(dialog, opener);
      return;
    }

    const closer = event.target.closest('[data-pm-qv-close]');
    if (closer) {
      event.preventDefault();
      close(closer.closest('dialog'));
      return;
    }

    // Clic en el fondo: el <dialog> recibe el evento solo si se pulsó fuera
    // del panel, porque el panel ocupa todo el contenido del diálogo.
    if (event.target.matches('.pm-qv')) close(event.target);
  });

  // Al agregar, el drawer del carrito se abre solo: la ventana sobra
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.pm-qv__form');
    if (!form) return;
    close(form.closest('dialog'));
  });

  /**
   * «Escribir una reseña» pulsa el botón del widget de Klaviyo, que es quien
   * abre el formulario. El widget se monta por JavaScript y no expone un
   * selector estable, así que se prueban los que usa hoy; si ninguno aparece
   * —widget no cargado, o cambió de marcado— el enlace sigue su href, que es
   * lo que ya hacía sin este código.
   */
  const KLAVIYO_WRITE = [
    '#klaviyo-reviews-list button[class*="write"]',
    '#klaviyo-reviews-list a[class*="write"]',
    '#klaviyo-reviews-list [data-testid*="write"]',
    '.kl-private-reset-css-Xuajs1 button[class*="write"]',
  ].join(',');

  document.addEventListener('click', (event) => {
    const cta = event.target.closest('[data-pm-write-review]');
    if (!cta) return;

    const native = document.querySelector(KLAVIYO_WRITE);
    if (!native) return; // sin widget, el enlace hace su trabajo

    event.preventDefault();
    native.click();
  });

  // El precio sigue a la variante elegida
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-pm-qv-variant]');
    if (!select) return;

    const dialog = select.closest('dialog');
    const price = dialog && dialog.querySelector('[data-pm-qv-price]');
    if (!price) return;

    const option = select.options[select.selectedIndex];
    const now = price.querySelector('.pm-price__now');
    if (now) now.textContent = option.dataset.price || now.textContent;

    let was = price.querySelector('.pm-price__was');
    if (option.dataset.compare) {
      if (!was) {
        was = document.createElement('span');
        was.className = 'pm-price__was';
        price.prepend(was);
      }
      was.textContent = option.dataset.compare;
    } else if (was) {
      was.remove();
    }
  });

  // Devolver el foco a donde estaba al cerrar
  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (!dialog.classList || !dialog.classList.contains('pm-qv')) return;
      if (dialog.returnFocus) dialog.returnFocus.focus({ preventScroll: true });
    },
    true
  );
})();
